<template>
  <div id="func-53">
    <span v-if="!beneficiarioSelecionado" class="title align-title">{{titulo}}</span>
  <GrupoFamiliar
    v-model="beneficiarioSelecionado"
    :style="beneficiarioSelecionado ? 'min-height: 600px' : ''"
    id-funcionalidade="53"
  >
      <StepFormulario
        :paciente="beneficiarioSelecionado"
        v-if="beneficiarioSelecionado"
      />
  </GrupoFamiliar>
  </div>
</template>
<script>
import GrupoFamiliar from '@/components/GrupoFamiliar/GrupoFamiliar'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import StepFormulario from '@/views/53/Steps/StepFormulario'
export default {
  data () {
    return {
      beneficiarioSelecionado: null,
      form: {}
    }
  },
  watch: {
    beneficiarioSelecionado: function (newVal) {
      const payload = {
        nome: newVal.beneficiarioDados.dadosPessoais.nome,
        contato: newVal.beneficiarioDados.dadosPessoais.contato,
        chaveUnica: newVal.beneficiarioDados.chaveUnica,
        numeroContrato: newVal.beneficiarioDados.dadosDoContrato.numeroContrato,
        tipoUser: newVal.beneficiarioDados.dadosDoPlano.tipoUsuario.descricao,
        integracao: newVal.beneficiarioDados.integracao
      }
      this.setPaciente(payload)
      if (newVal.beneficiarioDados.dadosDoPlano.tipoUsuario.codigo !== 'T' && this.idAgenda === '2') {
        this.$router.replace({ query: { step: '3.1', contrato: newVal.numeroContrato, breadCrumbItem: this.beneficiarioSelecionado.nome } })
      }
    }
  },
  methods: {
    ...mapActions('Func53', ['setPaciente']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP'])
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapState('Func53', ['idAgenda']),
    ...mapGetters('SetupApp', ['estilo']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    titulo () {
      return this.funcionalidade.parametros.textos.tituloSelecaoPaciente
    }
  },
  components: {
    StepFormulario,
    GrupoFamiliar
  },
  created () {
    this.SET_CURRENT_STEP(1)
  }
}
</script>
<style lang="less">
</style>
